import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import { HelmetProvider } from "react-helmet-async";
import ScrollToTop from "./components/ScrollToTop";

// Pages
import HomePage from "./pages/HomePage";
import CatalogPage from "./pages/CatalogPage";
import ProductPage from "./pages/ProductPage";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import CalculatorPage from "./pages/CalculatorPage";
import PromotionsPage from "./pages/PromotionsPage";
import GalleryPage from "./pages/GalleryPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import ReviewsPage from "./pages/ReviewsPage";
import ContactsPage from "./pages/ContactsPage";
import PrivacyPage from "./pages/PrivacyPage";
import CustomPage from "./pages/CustomPage";
import DeliveryPage from "./pages/DeliveryPage";
import CityPage from './pages/CityPage';
import CityDeliveryPage from "./pages/CityDeliveryPage";

// Admin Pages
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminOrdersPage from "./pages/AdminOrdersPage";
import AdminProductsPage from "./pages/AdminProductsPage";
import AdminGalleryPage from "./pages/AdminGalleryPage";
import AdminReviewsPage from "./pages/AdminReviewsPage";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <AuthProvider>
          <CartProvider>
            <BrowserRouter>
              <ScrollToTop />
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/catalog" element={<CatalogPage />} />
                <Route path="/product/:slug" element={<ProductPage />} />
                <Route path="/cart" element={<CartPage />} />
                <Route path="/checkout" element={<CheckoutPage />} />
                <Route path="/calculator" element={<CalculatorPage />} />
                <Route path="/promotions" element={<PromotionsPage />} />
                <Route path="/gallery" element={<GalleryPage />} />
                <Route path="/blog" element={<BlogPage />} />
                <Route path="/blog/:slug" element={<BlogPostPage />} />
                <Route path="/reviews" element={<ReviewsPage />} />
                <Route path="/contacts" element={<ContactsPage />} />
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route path="/custom" element={<CustomPage />} />
                <Route path="/delivery" element={<DeliveryPage />} />
                <Route path="/dostavka" element={<DeliveryPage />} />
                <Route path="/dostavka/:city" element={<CityDeliveryPage />} />
        <Route path="/city/:citySlug" element={<CityPage />} />
                
                {/* Admin Routes */}
                <Route path="/admin/login" element={<AdminLoginPage />} />
                <Route path="/admin/orders" element={<AdminOrdersPage />} />
                <Route path="/admin/products" element={<AdminProductsPage />} />
                <Route path="/admin/gallery" element={<AdminGalleryPage />} />
                <Route path="/admin/reviews" element={<AdminReviewsPage />} />
              </Routes>
            </BrowserRouter>
            <Toaster position="top-right" />
          </CartProvider>
        </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
